import APIclient from "API/Client";

export const RenameTeam = (teamId: string, newName: string) => {
  return APIclient.putData(`/ms/spm-organisation/v1/mgmt/budgets/${teamId}`, {
    name: newName,
  });
};
